<template>
  <Transition
    v-if="display || !loading"
    mode="out-in"
    enter-active-class="transition ease-in"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
    appear>
    <div v-if="loading" :class="{ 'flex justify-center': center }">
      <i class="fa-sharp fa-regular fa-spinner-third fa-fw fa-spin" :class="classes"></i>
      <span v-if="message" class="text-sm ml-2">{{ message }}</span>
    </div>
    <div v-else class="empty:hidden">
      <slot />
    </div>
  </Transition>
</template>

<script>
import { useSystemStore } from '@/stores/system'
import { mapState } from 'pinia'

export default {
  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    center: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    debounce: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useSystemStore, ['reducedMotion']),
    classes() {
      return this.color === 'white' ? 'text-white' : 'text-accent-500 dark:text-accent-600'
    }
  },
  data() {
    return {
      display: false,
      timeout: null
    }
  },
  mounted() {
    this.display = this.reducedMotion || !this.debounce
  },
  beforeUnmount() {
    clearTimeout(this.timeout)
  },
  watch: {
    loading: {
      handler(val) {
        clearTimeout(this.timeout)
        if (this.reducedMotion || !val) {
          return
        }

        if (this.debounce) {
          if (val) {
            this.display = false
          }
          this.timeout = setTimeout(() => (this.display = true), 1000)
        }
      },
      immediate: true
    }
  }
}
</script>
